<form *ngIf="inputForm" (keydown.enter)="$event.preventDefault()" [formGroup]="inputForm">
  <div *ngIf="countries">
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Select Filing Country</mat-label>
      <mat-select formControlName="filingCountry">
        <mat-option *ngFor="let country of countries" [value]="country.countryCode">
          {{country.displayText}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Arrangement Reference Id</mat-label>
      <input matInput formControlName="arrangementReferenceId" type="text" placeholder="Arrangement Reference Id">
      <mat-error *ngIf="inputFormErrors.arrangementReferenceId.required">
        Arrangement Reference Id is required!
      </mat-error>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Disclosure Reference Id</mat-label>
      <input matInput formControlName="disclosureReferenceId" type="text" placeholder="Disclosure Reference Id">
      <mat-error *ngIf="inputFormErrors.disclosureReferenceId.required">
        Disclosure Reference Id is required!
      </mat-error>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field appearance="outline" class="orbitax-date-picker flex-0-0-405px">
      <mat-label>Date Of Arrangement</mat-label>
      <input matInput formControlName="dateOfArrangement" [matDatepicker]="picker1"
             placeholder="Select Date Of Arrangement"
             particleAnalytics
             analyticsCategory="date-time-cell"
             analyticsAction="date-picker">
      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
      <mat-datepicker #picker1></mat-datepicker>
      <mat-error *ngIf="inputFormErrors.dateOfArrangement.required">
        Date Of Arrangement is required!
      </mat-error>
    </mat-form-field>
  </div>
  <div>
    <div class="inline-fileuploader flex-1-1-100">
      <input hidden type="file"
             (change)="onFileSelect($event)"
             [accept]="acceptedTypes" #fileInput/>

      <button mat-stroked-button
              class="mat-raised-button browse-btn"
              (click)="fileInput.click()"
              aria-label="add file"
              particleAnalytics
              analyticsCategory="file-selector"
              analyticsAction="add-file-btn">
          <span class="mat-button-wrapper">
            Browse for file<mat-icon>arrow_forward_ios</mat-icon>
          </span>
      </button>
      <button *ngIf="file" mat-button class="upload-file-remover-btn"
              (click)="removeFile()"
              aria-label="remove file"
              particleAnalytics
              analyticsCategory="file-selector"
              analyticsAction="upload-remover-btn">
        <span matTooltip="{{file.name}}" class="text-truncate">{{file.name}}</span> &nbsp;
        ({{file.size / 1024 | number:'0.0-1'}}KB)
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div>
  <div class="m-t-10 m-b-10 mat-error">
    {{FileError}}
  </div>
</form>
